import { state } from "../state/workspaceStore.js";
import { size, money } from "../utils/format.js";
import { head } from "../components/common/PageHeader.jsx";
import {
  btn,
  select,
  field,
  errorSlot,
} from "../components/forms/FormControls.jsx";
import { nodes } from "../components/common/reactHelpers.jsx";
import { tableViews } from "../components/tables/RecordTable.jsx";
export function orderForm() {
  if (!state.orderDraft)
    state.orderDraft = {
      customerId: state.db.customers[0]?.id || "",
      coupon: "",
      offer: "",
      lines: [
        {
          productId: "",
          skuId: "",
          qty: 1,
        },
      ],
    };
  const d = state.orderDraft;
  const options = state.db.products
    .filter((p) => !p.archived && p.status === "Active")
    .flatMap((p) =>
      p.skus
        .filter((s) => s.stock > 0)
        .map((s) => [
          p.id + "|" + s.id,
          `${p.name} · ${s.variant} · ${size(s)} · ${money(s.price)} · ${s.stock} in stock`,
        ]),
    );
  return (
    <>
      {head(
        "OPERATIONS",
        "Create order",
        "Preview current configured pricing before saving an order.",
        btn("Cancel", 'data-nav="orders"', true),
      )}
      {
        <form id={"order-new-form"} className={"grid-detail"}>
          <section className={"card"}>
            <h2>{"Customer & items"}</h2>
            {select(
              "Customer",
              "customerId",
              d.customerId,
              state.db.customers.map((c) => [c.id, c.name + " · " + c.city]),
            )}
            {nodes(
              d.lines.map((l, i) => (
                <div className={"sku-block"}>
                  <div className={"form-grid"}>
                    {select(
                      "SKU",
                      `line-${i}`,
                      l.productId ? l.productId + "|" + l.skuId : "",
                      [["", "Choose available SKU…"], ...options],
                    )}
                    {field(
                      "Quantity",
                      `qty-${i}`,
                      l.qty,
                      "number",
                      'min="1" step="1" required',
                    )}
                  </div>
                  {d.lines.length > 1
                    ? btn("Remove line", `data-remove-line="${i}"`, true)
                    : ""}
                </div>
              )),
            )}
            <div className={"space-top"}>
              {btn("＋ Add line", 'data-action="add-line"', true)}
            </div>
            <div className={"form-grid space-top"}>
              {field("Coupon (optional)", "coupon", d.coupon)}
            </div>
            {btn("Calculate order", 'data-action="calculate-order"', true)}
            <button className={"btn"} type={"submit"}>
              {"Create order"}
            </button>
            {errorSlot()}
          </section>
          <section className={"card"}>
            <h2>{"Order calculation"}</h2>
            {state.quote ? (
              <>
                <div className={"total-row"}>
                  {"Merchandise "}
                  <b>{money(state.quote.subtotal)}</b>
                </div>
                <div className={"total-row"}>
                  {"Discount "}
                  <b>
                    {"\u2212 "}
                    {money(state.quote.discount)}
                  </b>
                </div>
                <div className={"total-row"}>
                  {"Shipping "}
                  <b>{money(state.quote.shipping)}</b>
                </div>
                <div className={"total-row grand"}>
                  {"Total "}
                  <b>{money(state.quote.total)}</b>
                </div>
              </>
            ) : (
              <p className={"hint"}>
                {"Choose items and calculate to see the total."}
              </p>
            )}
            <p className={"hint"}>
              {"Minimum merchandise value "}
              {money(state.db.settings.minimumOrder)}
              {". Shipping "}
              {money(state.db.settings.shippingFee)}
              {"; free strictly above "}
              {money(state.db.settings.freeThreshold)}
              {" before discounts. Stock is reserved once, on creation."}
            </p>
          </section>
        </form>
      }
    </>
  );
}
export default function OrderFormPage({ recordId } = {}) {
  return tableViews(orderForm());
}
